import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gesung_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Separate client for public customer accounts (distinct token from admin).
export const accountApi = axios.create({ baseURL: API });

accountApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("gesung_account_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
